import React from "react";
const IconInclinedStar = (props: React.SVGProps<SVGSVGElement>) => (
  <svg height="8" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 9 9" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="m5.297.06.842 2.823 2.83.928-2.457 1.648-.007 2.938-2.36-1.804-2.833.888.998-2.763L.565 2.33l2.977.096L5.297.061Z"
      fill="currentColor"
    />
  </svg>
);
export default IconInclinedStar;
